import React, { FC } from "react";
import { useLocale } from "../../../../contexts/localeContext";
import { TranslationKeys } from "../../../../contexts/TranslationKeys";
import ShortcutWidget from "../shortcut-widget";
import { useFormikContext } from "formik";
import { Button } from '../../../../components/button/Button';

interface SummaryStepProps {
    onBack: () => void;
    selectedMenu: string;
}

const SummaryStep: FC<SummaryStepProps> = ({ onBack, selectedMenu }) => {
    const { translate } = useLocale();
    const { values } = useFormikContext<any>();

    return <div className="flex flex-col pr-3 h-full relative">
        <div className="flex flex-row py-3">
            <div className="flex flex-col w-40">
                <span className="text-xs text-gray-600 mb-1 font-semibold">{translate.byKey(TranslationKeys.menu)}</span>
            </div>
            <div className="flex flex-col">
                <span className="text-xs mb-1 font-semibold">{selectedMenu}</span>
            </div>
        </div>
        <hr />
        <div className="flex flex-row py-3">
            <div className="flex flex-col w-40">
                <span className="text-xs text-gray-600 mb-1 font-semibold">{translate.byKey(TranslationKeys.preview)}</span>
            </div>
            <div className="flex flex-col">
                <ShortcutWidget widget={values} previewMode={true} />
            </div>
        </div>
        <hr />
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className="secondary secondary-inverse py-1 px-5 "
                    type="button"
                    onClick={onBack}>{translate.byKey(TranslationKeys.back)}
                </button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <Button
                    variant="submit"
                    shape="pill"
                    type="submit">
                    {translate.byKey(TranslationKeys.confirm)}
                </Button>
            </div>
        </div>
    </div>
}

export default SummaryStep;